// extracted by mini-css-extract-plugin
module.exports = {"faq":"SectionFaq_faq__0iSzs","container":"SectionFaq_container__2TGof","faq__title":"SectionFaq_faq__title__VVAW3","faq__list-container":"SectionFaq_faq__list-container__709L_"};